import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledWrapper = styled.form`
  width: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
